import React, {useState, useEffect} from 'react';
import {Link, Route, useParams} from 'react-router-dom';
import axios from 'axios';
import EventDetail from './event-detail'

function EventList (){
    const [events, setEvents] = useState([]);
    const [eventTag, setEventTag] = useState([]);
    const [eventsNumber, setEventsNumbers] = useState([]);
    const [tagAll, setTagAll] = useState(false);
    const [tagDigital, setTagDigital] = useState(false);
    const [tagRecommendation, setTagRecoomendation] = useState(false);
    const [tagFreeAdmission, setTagFreeAdmission] = useState(false);
    const [tagCancel, setTagCancel] = useState(false);
    const [tagPostponed, setTagPostponed] = useState(false);

    const {tag} = useParams();

    useEffect(()=>{
        getEventList()
    }, [tag]);

    useEffect(()=>{
        allTagStateChange()
    }, []);

    const image_in_list = `${process.env.PUBLIC_URL}/project_event.jpg`;
    let empty_copy_right_el;


    const allTagStateChange =()=>{
        setTagAll(true);
        setTagDigital(false);
        setTagRecoomendation(false);
        setTagCancel(false);
        setTagPostponed(false);
        setTagFreeAdmission(false)

    }

    const digitalTagStateChange =()=>{
        setTagAll(false);
        setTagDigital(true);
        setTagRecoomendation(false)
        setTagCancel(false);
        setTagPostponed(false);
        setTagFreeAdmission(false)
    }


    const freeAdmissionTagStateChange =()=>{
        setTagAll(false);
        setTagDigital(false);
        setTagRecoomendation(false)
        setTagCancel(false);
        setTagPostponed(false);
        setTagFreeAdmission(true)
    }

    const recommendationTagStateChange =()=>{
        setTagAll(false);
        setTagDigital(false);
        setTagRecoomendation(true)
        setTagCancel(false);
        setTagPostponed(false);
        setTagFreeAdmission(false)
    }

    const cancelTagStateChange =()=>{
        setTagAll(false);
        setTagDigital(false);
        setTagRecoomendation(false)
        setTagCancel(true);
        setTagPostponed(false);
        setTagFreeAdmission(false)
    }

    const postponedTagStateChange =()=>{
        setTagAll(false);
        setTagDigital(false);
        setTagRecoomendation(false)
        setTagCancel(false);
        setTagPostponed(true);
   
    }

    function getEventList(){
        axios.get('/api/current_event_list/'+tag)
        .then(eventListFromMongo=>{
            setEvents(eventListFromMongo.data);
            setEventsNumbers(eventListFromMongo.data.length)
        })
        .catch(error=>{
            console.log(error)
        })
    };

    const all = 
    (tag=='all')?<div>
    <p className='result_number'>All Event / {eventsNumber} Events</p>
    </div>:'';

    const isFreeAdmission = 
    (tag=='isFreeAdmission')?<div>
    <p className='result_number'>Free Admission  / {eventsNumber} Events</p>
    </div>:'';

    const isRecommendation = 
    (tag=='isRecommendation')?<div>
    <p className='result_number'>Recommendation  / {eventsNumber} Events</p>
    </div>:'';

    const cancel = 
    (tag=='cancel')?<div>
    <p className='result_number'>Canceled Event  / {eventsNumber} Events</p>
    </div>:'';

    const postponed = 
    (tag=='postponed')?<div>
    <p className='result_number'>Postponed Event  / {eventsNumber} Events</p>
    </div>:'';

    const digital = 
    (tag=='digital')?<div>
    <p className='result_number'>Digitale Event  / {eventsNumber} Events</p>
    </div>:'';


    return(
        <div className='eventList'>
            <div className='current_upcoming_event_flex'>
            <p className='current_in_current_event'>Current Events</p>
            <Link to='/events/upcoming/list/all'><p className='upcoming_in_current_event'>Upcoming Events</p></Link>
            </div>
             
            <div className='event_tag_gruop'>               
               <Link to='/events/current/list/isFreeAdmission'  onClick={freeAdmissionTagStateChange } className={`tag_event ${tagFreeAdmission? "highlight_tag" :"normal_tag"}`}>Free Admission</Link>
               <Link to='/events/current/list/isRecommendation' onClick={ recommendationTagStateChange} className={`tag_event ${tagRecommendation? "highlight_tag" :"normal_tag"}`} >Recommendation</Link>
               <Link to='/events/current/list/cancel'  onClick={ cancelTagStateChange} className={`tag_event ${tagCancel? "highlight_tag" :"normal_tag"}`}>Cancel</Link>
               <Link to='/events/current/list/postponed'  onClick={postponedTagStateChange } className={`tag_event ${tagPostponed? "highlight_tag" :"normal_tag"}`}>Postponed</Link>
               <Link to='/events/current/list/digital'  onClick={ digitalTagStateChange} className={`tag_event ${tagDigital? "highlight_tag" :"normal_tag"}`}>Digital</Link>
               <Link to='/events/current/list/all' onClick={ allTagStateChange } className={`tag_event ${tagAll? "highlight_tag" :"normal_tag"}`}>All</Link>
            </div>

            <div>{all}</div>
            <div>{isFreeAdmission}</div>
            <div>{isRecommendation}</div>
            <div>{postponed}</div>
            <div>{cancel}</div>
            <div>{digital}</div>



               {/* <Link to='/events/map'>to Map</Link> */}
            <ul className='event_list'>
              {(events)?<div>
                {events.map((event)=>
              <li key={event._id}><Link to={`/events/current/list/${tag}/detail/${event._id}`}>
                   <div className='event_list_img_wrapper'>
                   <img src={event.image==''? image_in_list:event.image}/>
                   <h3>{event.name}</h3>
                   <h4>{event.sameday=='Yes'? event.modifyOpnday : event.modifyOpnday +' - '+ event.modifyClsday}</h4>
                   <p>{event.image_copyright==''?empty_copy_right_el:event.image_copyright}</p>
                   </div>
                  </Link>
                  </li>
              )}
              </div>:''}
             </ul>
         
        </div>
    )
}

export default EventList;